export default __webpack_public_path__ + "static/ellipse-glow-horizontal-mobile-f87b8de8e5e92b62d9a5812a08279147.png";